<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="{ name: 'Pre Plan' }" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditBroadcaster") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.BroadcasterCode')"
              >
                <vs-input
                  :label="$t('setup.label.BroadcasterCode')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.broadcasterCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Address')"
              >
                <vs-input
                  :label="$t('setup.label.Address')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.address"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required|alpha_spaces"
                v-slot="{ errors }"
                :name="$t('setup.label.ContactName')"
              >
                <vs-input
                  :label="$t('setup.label.ContactName')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.contactName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required|email"
                v-slot="{ errors }"
                :name="$t('setup.label.Email')"
              >
                <vs-input
                  :label="$t('setup.label.Email')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.email"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required|alpha_spaces"
                v-slot="{ errors }"
                :name="$t('setup.label.BroadcasterName')"
              >
                <vs-input
                  :label="$t('setup.label.BroadcasterName')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.broadcasterName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required|numeric"
                v-slot="{ errors }"
                :name="$t('setup.label.GstRegNumber')"
              >
                <vs-input
                  :label="$t('setup.label.GstRegNumber')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.pin"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required|digits:10"
                v-slot="{ errors }"
                :name="$t('setup.label.MobileNumber')"
              >
                <vs-input
                  :label="$t('setup.label.MobileNumber')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.contactMobile"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
              <ValidationProvider
                rules="required|digits:10"
                v-slot="{ errors }"
                :name="$t('setup.label.LandlineNumber')"
              >
                <vs-input
                  :label="$t('setup.label.LandlineNumber')"
                  class="w-full mb-2 font-semibold"
                  v-model="broadcasterInfo.contactNumber"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="updateBroadcaster"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const broadcasterEmptyObj = {
  id: 0,
  address: "",
  broadcasterCode: "",
  broadcasterName: "",
  contactMobile: "",
  contactName: "",
  contactNumber: "",
  email: "",
  locale: "en",
  pin: "",
};

export default {
  data() {
    return {
      broadcasterInfo: broadcasterEmptyObj,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      broadcasterData: (state) => state.broadcaster.broadcasterById,
    }),
  },
  methods: {
    async updateBroadcaster() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      delete this.broadcasterInfo.id;
      delete this.broadcasterInfo.channelDatas;

      try {
        await this.$store.dispatch("broadcaster/editBroadcasterAction", {
          id: this.$route.params.id,
          data: this.broadcasterInfo,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Brodcuster Edited Successfully!",
          type: "success",
        });

        this.$router.push({ name: "Pre Plan" });
        this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getBroadcasterData() {
      try {
        await this.$store.dispatch(
          "broadcaster/setBroadcasterById",
          this.$route.params.id
        );
        this.broadcasterInfo = this.broadcasterData;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    cancel() {
      this.$router.push({ name: "Pre Plan" });
    },
    resetForm() {
      this.broadcasterInfo = broadcasterEmptyObj;
      this.broadcasterInfo.address = "";
      this.broadcasterInfo.broadcasterCode = "";
      this.broadcasterInfo.broadcasterName = "";
      this.broadcasterInfo.contactMobile = "";
      this.broadcasterInfo.contactName = "";
      this.broadcasterInfo.email = "";
      this.broadcasterInfo.pin = "";
      this.broadcasterInfo.contactNumber = "";
    },
  },
  mounted() {
    this.getBroadcasterData();
  },
};
</script>
